import * as Common from "../../commons/common"

export class SumupListCondition {
  id: string = ""
  month: string = ""
  name: string = ""
  sumup_kind: string = ""
  page: number = 1
  row_count: number =  Common.SheetListRowCount
}

export class SumupGroup {
  id: number
  nendo: number
  exec_times: number
  exec_date: string
  name: string
  is_exists_sumup_data: boolean
  created_at: string
  isSelected: boolean = false
  curriculum_count: number
  curriculum_ids: number[]
  saiten_completed: boolean

  constructor(sumupGroup: any){
    this.id = sumupGroup.id;
    this.nendo = sumupGroup.nendo;
    this.exec_times = sumupGroup.exec_times;
    this.exec_date = sumupGroup.exec_date;
    this.is_exists_sumup_data = sumupGroup.is_exists_sumup_data;
    this.created_at = sumupGroup.created_at;
    this.name = sumupGroup.name;
    this.saiten_completed = sumupGroup.saiten_completed;
    this.curriculum_ids = sumupGroup.curriculum_ids;
  }
}